export * from './one-column/one-column.layout';
export * from './two-columns/two-columns.layout';
export * from './three-columns/three-columns.layout';
export * from './sample/sample.layout';



// WEBPACK FOOTER //
// /var/www/minha-netsul/src/app/@theme/layouts/index.ts